// extracted by mini-css-extract-plugin
module.exports = {"customNav":"navbar-module--customNav--1o6Vz","active":"navbar-module--active--p1S-Q","link":"navbar-module--link--1s-T7"};